module.exports = __webpack_public_path__ + "static/img/oilcard_bg.077dae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oilcard_bg.png
// module id = qP0y
// module chunks = 0